import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs'

@Injectable()

export default class NavMenuService {

    private _activated$ : Subject<boolean> = new Subject<boolean>();
    
    private activatedObservable : Observable<boolean> = this._activated$ as Observable<boolean>;

    setActivated(data : boolean) {
        this._activated$.next(data);
    }

    getActivated(){
        return this.activatedObservable;        
    }    
}